import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { getApiBaseUrl } from '../../utils/utils'; 
export default function AttendanceSetting() {

    const API_URL = process.env.REACT_APP_API_URL;
    const [msg, setMsg] = useState('')
    const [errormsg, setError] = useState('')
    const navigate = useNavigate();


 



    const [searchQuery, setSearchQuery] = useState("");

    const [partners, setPartners] = useState([]);
    useEffect(() => {
        const fetchPartners = async () => {

            const baseApiUrl = getApiBaseUrl();
            try {
                const response = await axios.get(`${baseApiUrl}/v1.0/partner/retrieve_list?page=0`);
                setPartners(
                    (response.data.data || [])
                );

            } catch (err) {
                setError(err.message || 'Error fetching data');
            } finally {
                // setLoading(false);
            }
        };

        fetchPartners();
    }, []);

    const [selectedPartner, setSelectedPartner] = useState('0');

    const handleSelectChange = (e) => {
        const partnerId = e.target.value;

        if (partnerId === '0') {
            setSelectedPartner('0');

            return;
        }

        const partner = partners.find((p) => String(p.pid) === partnerId);
        setSelectedPartner(partner.pid);
        getHomebaseList(partner.pid)

    };


    const [settings, setSettings] = useState({
        require_attendance: false,
        login_logout_required: false,
        logout_anywhere_allowed: false,
        geo_restriction_enabled: false,
        multiple_locations_allowed: false,
        locations: [],
        drivers: []
    });

    useEffect(() => {
        // Fetch drivers from the API on component mount
        fetchDrivers();
        // getHomebaseList();

    }, []);

    console.log(settings)



    const [homebases, sethomebases] = useState([])
    const getHomebaseList = async (selectedPartner) => {
        const API_PATH = `${API_URL}shypvdriverapp/partner-warehouse?partnerId=${selectedPartner}`;

        try {
            const res = await axios.get(API_PATH);
            console.log(res.data);
            if (res.data.success == true) {
                sethomebases(res.data.data);
            } else {
                console.log('false')
            }

        } catch (err) {
            console.log(err);
        }
    };



    const locationOptions = homebases.map((homebase) => ({
        value: homebase.id, // or homebaseName if you prefer
        label: homebase.name,
    }));



    const [scaninfo, setScanInfo] = useState({
        drivers: [],
        locations: [],
    });


    console.log('homebases', homebases)
    console.log('drivers', scaninfo)
    const [drivers, setDrivers] = useState()
    const fetchDrivers = async () => {
        try {
            // Replace this API endpoint with the actual one that fetches drivers based on the emirate
            const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

            if (response.data.success) {
                const driversData = response.data.data;  // The array of driver objects

                // Map the response to extract driverId and name
                const driversList = driversData.map(driver => ({
                    driver_id: driver.driverId,
                    driver_name: driver.name
                }));

                // Set the drivers state
                setDrivers(driversList);
            } else {
                console.error('Error fetching drivers for emirate:');
            }
        } catch (error) {
            console.error('Error fetching drivers:', error);
        }
    };

    const filteredDrivers = Array.isArray(drivers)
        ? drivers.filter(driver =>
            driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        : [];

    const driverOptions = filteredDrivers.map(driver => ({
        value: driver.driver_id,
        // label: driver.driver_name
        label: `${driver.driver_id} - ${driver.driver_name}`
    }));

      const buttonsyle = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginRight: '10px',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%'
    }


   

    const saveConfig = async () => {
        setError('')
    const API_PATH = `${API_URL}shypvdriverapp/attendance-config/new`;

    try {
        const payload = {
            
            requireAttendance: settings.require_attendance == 1 ? true : false,
            allowLogoutAnywhere: settings.logout_anywhere_allowed == 1 ? true : false,
            enableGeoRestriction: settings.geo_restriction_enabled == 1 ? true : false,
            driverIds: settings.drivers.map(Number), // convert all IDs to numbers
            partnerId: Number(selectedPartner), // assuming user id is partnerId
            checkinWarehouseIds: settings.locations.map(Number),
            checkoutWarehouseIds: settings.locations.map(Number), // or use a different field if you have
        };

        const res = await axios.post(API_PATH, payload, {
            headers: { 'Content-Type': 'application/json' },
        });

        if (res.data.success) {
            console.log('Attendance settings saved successfully:', res.data);
            navigate('/orders/attendance-config');
        } else {
            console.log('Failed to save settings:', res.data.message);
            setError('Failed to save settings:', res.data.message)
        }
    } catch (err) {
        console.error('Error saving attendance settings:', err);
    }
};


    return (
        <div>

            <div className="form-container">
                <div className="row">
                    <div className="col-md-6">
                        <h5 style={{ float: 'left' }}>Attendance Settings </h5>
                    </div>

                </div>

                <div className="row">
                    <div className="col-md-6">


                        <div className="form-group">
                            <label htmlFor="formGroupExampleInput2" className="m-form">Partner*</label>
                            <select onChange={handleSelectChange} value={selectedPartner} style={{ marginRight: '10px' }}>
                                <option value="" disabled>
                                    -- Select a partner --
                                </option>
                                <option value="0">All</option>
                                {partners && [...partners].sort((a, b) => a.pname.localeCompare(b.pname)).map((partner) => (
                                    <option key={partner.pid} value={partner.pid}>
                                        {partner.pname}
                                    </option>
                                ))}
                            </select>

                        </div>

                    </div>




                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="formGroupExampleInput2" className="m-form">Required Attendance</label>
                            <select value={settings.require_attendance} onChange={e => setSettings({ ...settings, require_attendance: e.target.value })} style={{ marginRight: '10px' }}>

                                <option value="0">NO</option>
                                <option value="1">YES</option>

                            </select>

                        </div>

                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="formGroupExampleInput2" className="m-form">Required Logout attendance?</label>
                            <select value={settings.login_logout_required}
                                onChange={e => setSettings({ ...settings, login_logout_required: e.target.value })}
                                disabled={!settings.require_attendance} style={{ marginRight: '10px' }}>

                                <option value="0">NO</option>
                                <option value="1">YES</option>

                            </select>

                        </div>

                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="formGroupExampleInput2" className="m-form">Allow Logout anywhere?</label>
                            <select value={settings.logout_anywhere_allowed}
                                onChange={e => setSettings({ ...settings, logout_anywhere_allowed: e.target.value })}
                                disabled={!settings.require_attendance || !settings.login_logout_required} style={{ marginRight: '10px' }}>

                                <option value="0">NO</option>
                                <option value="1">YES</option>

                            </select>

                        </div>

                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="formGroupExampleInput2" className="m-form">Enable Geo Restrictions? </label>
                            <select onChange={e => setSettings({ ...settings, geo_restriction_enabled: e.target.value })}
                                disabled={!settings.require_attendance} value={settings.geo_restriction_enabled} style={{ marginRight: '10px' }}>

                                <option value="0">NO</option>
                                <option value="1">YES</option>

                            </select>

                        </div>

                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="formGroupExampleInput2" className="m-form">Select Drivers </label>

                            <Select
                                isMulti
                                options={driverOptions}
                                value={
                                    driverOptions.filter(option =>
                                        scaninfo?.drivers?.includes(option.value)
                                    ) || []
                                }
                                onChange={(selectedOptions) => {
                                    const selectedValues = selectedOptions
                                        ? selectedOptions.map(option => option.value)
                                        : [];
                                    setScanInfo({ ...scaninfo, drivers: selectedValues });
                                    setSettings({ ...settings, drivers: selectedValues });
                                }}


                                placeholder="Select drivers"
                                // onInputChange={(newValue) => setSearchQuery(newValue)}
                                isSearchable
                                noOptionsMessage={() => "No drivers found"}
                            />

                        </div>
                    </div>








                </div>

                {settings.geo_restriction_enabled && (
                    <div className="form-group">
                        <div className="row">

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="formGroupExampleInput2" className="m-form">
                                        Select Locations
                                    </label>

                                    <Select
                                        isMulti
                                        options={locationOptions}
                                        value={
                                            locationOptions.filter(option =>
                                                settings?.locations?.includes(option.value)
                                            ) || []
                                        }
                                        onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions
                                                ? selectedOptions.map(option => option.value)
                                                : [];
                                            setSettings({ ...settings, locations: selectedValues });
                                        }}
                                        placeholder="Select locations"
                                        isSearchable
                                        noOptionsMessage={() => "No locations found"}
                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                )}

 <a onClick={saveConfig} style={buttonsyle} type="button" className="btn-demo add">
                                    Submit
                                </a>
                                <p>{errormsg}</p>

            </div>
        </div>
    )
}
